import {
  DataTable,
  DataTablePagination,
  DataTableSearch,
} from "@bleu.builders/ui";
import React from "react";
import { useParams } from "react-router-dom";

import { ContentLayout } from "#/components/ContentLayout";
import { withPaywall } from "#/components/WithPaywall";
import { replaceParams, UserPagePath } from "#/lib/pagesHelper";
import { canViewDiagnosis } from "#/lib/permissions";
import { useSWRDataTableWithRedirect } from "#/utils/useSWRDataTableWithRedirect";

import { DiagnosesActions } from "./(components)/actions";
import { DiagnosesTable } from "./(components)/DiagnosesTable";

function DiagnosesPage() {
  const params = useParams();
  const { data, error, isLoading, tableState, setTableState } =
    useSWRDataTableWithRedirect(replaceParams(UserPagePath.DIAGNOSES, params), {
      sorting: [{ id: "created_at", desc: true }],
    });

  return (
    <ContentLayout
      title="Diagnósticos"
      description="Responda o formulário de diagnóstico e localize, de forma automatizada, as melhores oportunidades tributárias aplicáveis a um cliente – mapeadas através de um algoritmo validado por nossos tributaristas – e exporte o relatório pronto."
      actions={<DiagnosesActions />}
    >
      <DataTable
        data={data}
        error={error}
        tableState={tableState}
        setTableState={setTableState}
        setSelectedData={null}
        setQueryToParams={true}
      >
        <div className="space-y-4">
          <div className="flex flex-col justify-start">
            <span className="font-semibold text-base">Buscar</span>
            {/* @ts-ignore */}
            <DataTableSearch placeholder="Pesquise por nome do cliente" />
          </div>
          {isLoading ? (
            <div className="space-y-4 size-full overflow-y-auto max-h-[80vh] min-h-[10vh] animate-pulse text-muted">
              Carregando...
            </div>
          ) : (
            <>
              <div>
                <DiagnosesTable />
              </div>
              <DataTablePagination />
            </>
          )}
        </div>
      </DataTable>
    </ContentLayout>
  );
}

export default withPaywall(DiagnosesPage, canViewDiagnosis);
